import { ProcessedEvent } from '@aldabil/react-scheduler/types';
import ScheduleCanlendar from '@src/components/schedule/calendar';
import { useCallback, useEffect, useState } from 'react';
import placeApi from '@src/services/api/place';
import useBookingSchedule from '@src/hooks/useBookingSchedule';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { MenuItem, Select } from '@mui/material';

const SelectWrap = styled.div`
  display: flex;
  justify-content: end;
  gap: 12px;
  > div {
    width: 200px;
  }
`;

export default function BookingScheduleAdmin() {
  const [selectDate, SetSelectDate] = useState(new Date(dayjs().add(1, 'month').format()));
  const [status, setStatus] = useState<'AFTER' | 'BEFORE'>();
  const { list, loading, colors, resource } = useBookingSchedule(selectDate, undefined, status, 'admin');
  const handleChangeTargetMonth = useCallback((date: Date) => {
    SetSelectDate(date);
  }, []);

  return (
    <div>
      <SelectWrap>
        <div>
          <Select
            value={status}
            onChange={event => setStatus(event.target.value as typeof status)}
            size="small"
            fullWidth
          >
            <MenuItem value={undefined}>All</MenuItem>
            <MenuItem value="BEFORE">예약 대기</MenuItem>
            <MenuItem value="AFTER">예약 완료</MenuItem>
          </Select>
        </div>
      </SelectWrap>
      <ScheduleCanlendar
        event={list}
        resource={resource}
        loading={loading}
        selectDate={selectDate}
        handleChange={handleChangeTargetMonth}
      ></ScheduleCanlendar>
    </div>
  );
}
